export const frameSvg = (
  <svg viewBox="0 0 153.42 152.94">
    <path
      fill="currentColor"
      d="M145.15,75.59v-58a9.29,9.29,0,0,0-9.3-9.28H77.65a2.24,2.24,0,0,1-1.56-.64l-7-7A2.24,2.24,0,0,0,67.48,0H9.31A9.29,9.29,0,0,0,0,9.27H0v58a2.16,2.16,0,0,0,.65,1.55l7,7a2.16,2.16,0,0,1,.65,1.55v58a9.29,9.29,0,0,0,9.3,9.28H75.8a2.24,2.24,0,0,1,1.56.64l7,7a2.24,2.24,0,0,0,1.56.64h58.19a9.29,9.29,0,0,0,9.31-9.27h0v-58a2.16,2.16,0,0,0-.65-1.55l-7-7A2.17,2.17,0,0,1,145.15,75.59Zm-39.8,30.69H48.18A1.32,1.32,0,0,1,46.87,105V48a1.35,1.35,0,0,1,1.31-1.33h57.17A1.34,1.34,0,0,1,106.68,48v57a1.33,1.33,0,0,1-1.33,1.32Z"
      transform="translate(0 0)"
    />
  </svg>
)
